import { EVENT_TYPE } from '@/common/resources/const'

/**
 * find on-click from event list
 * @param eventList
 * @returns {*}
 */
export const getOnClick = (eventList = []) => {
  return eventList.find((event) => event.type === EVENT_TYPE.ON_CLICK)
}
